import {
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Transform criteria.custom_404 into Branding Custom 404 sub-item data.
 * Legacy behavior: if not detected, show "No Custom 404 Page was found."
 *
 * @param {Object} custom404Criteria - criteria.custom_404
 */
export const transformCustom404 = (custom404Criteria) => {
  if (!custom404Criteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Custom 404 Page was found.',
      data: null,
    };
  }

  const wooRankImportance = custom404Criteria?.importance ?? 0;
  const wooRankSolvability = custom404Criteria?.solvability ?? 0;

  const detected = Boolean(custom404Criteria?.data?.detected);
  const statusCode = custom404Criteria?.data?.statusCode ?? null;

  return {
    status: detected ? 'success' : 'error',
    iconType: detected ? 'success' : 'error',
    importance: getImportance(wooRankImportance),
    solvability: getSolvability(wooRankSolvability),
    isEmpty: !detected,
    message: detected ? null : 'No Custom 404 Page was found.',
    data: detected
      ? {
          statusCode,
        }
      : null,
  };
};

export default transformCustom404;


